import { render, staticRenderFns } from "./ActivateEmail.vue?vue&type=template&id=0920c1ca&"
import script from "./ActivateEmail.vue?vue&type=script&lang=js&"
export * from "./ActivateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports